import { render, staticRenderFns } from "./Regist.List.vue?vue&type=template&id=6a74b62b&"
import script from "./Regist.List.vue?vue&type=script&lang=js&"
export * from "./Regist.List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports